import React from "react";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import helpers from "@sistemas.mundo/helper-functions";
import { es } from "date-fns/locale";

export default function CustomDatePicker({
  size = "medium",
  register,
  name,
  label,
  value = null,
  cancelText = "Cancelar",
  clearText = "Limpiar",
  inputFormat = "dd/MM/yyyy",
  returnFormat = "YYYY/MM/DD",
  leftArrowButtonText = "Anterior",
  rightArrowButtonText = "Siguiente",
  clearable = false,
  disabled = false,
  required = false,
  showToolbar = false,
  orientation = "portrait",
  onOpen = null,
  onClose = null,
  onAccept = null,
  onYearChange = null,
  onChange = null,
  onBlur = null,
  loading = false,
  hashError = null,
  minDate = "1900/01/01",
  maxDate = "2100/01/01",
  preventSubmitOnEnter=true,
}) {
  const handleOnChange = (data) => {
    if (onChange) onChange(data);
  };

  const handleOnBlur = (data) => {
    if (onBlur) onChange(data);
  };

  if (value && !(value instanceof Date)) {
    value = helpers.date.formatDateString(value, "YYYY/MM/DD");
    value = new Date(value);
  }

  const handleOnKeyDown = (event) => {
    if (preventSubmitOnEnter && event.keyCode === 13 ) {
        event.preventDefault()
        event.stopPropagation();
    }
}


  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={es}>
      <DatePicker
        size={size}
        mask="__/__/____"
        minDate={new Date(minDate)}
        maxDate={new Date(maxDate)}
        fullWidth={true}
        label={label}
        value={value}
        inputFormat={inputFormat}
        onYearChange={onYearChange}
        clearText={clearText}
        leftArrowButtonText={leftArrowButtonText}
        rightArrowButtonText={rightArrowButtonText}
        cancelText={cancelText}
        loading={loading}
        clearable={clearable}
        disabled={disabled}
        onOpen={onOpen}
        showToolbar={showToolbar}
        onClose={onClose}
        onAccept={onAccept}
        orientation={orientation}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        renderInput={(params) => (
          <TextField
          onKeyDown={handleOnKeyDown}
            fullWidth={true}
            {...params}
            id={name}
            error={hashError ? hashError.value : false}
            helperText={hashError ? hashError.message : ""}
            {...register(name, {
              required: required,
            })}
          />
        )}
      />
    </LocalizationProvider>
  );
}
